import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
//#region src/modules/ServicePeriods/queries/group-instances-by-day.ts
dayjs.extend(utc);
dayjs.extend(timezone);
function toZoned(iso, timeZone) {
	return timeZone ? dayjs(iso).tz(timeZone) : dayjs(iso);
}
function formatDayLabel(dateKey, timeZone) {
	return (timeZone ? dayjs.tz(dateKey, timeZone) : dayjs(dateKey)).format("dddd, MMMM D, YYYY");
}
function groupInstancesByCalendarDay(instances, timeZone) {
	const groups = [];
	instances.forEach((instance) => {
		const dateKey = toZoned(instance.endsAt, timeZone).format("YYYY-MM-DD");
		const current = groups.at(-1);
		if (current?.dateKey === dateKey) {
			current.instances.push(instance);
			return;
		}
		groups.push({
			dateKey,
			instances: [instance],
			label: formatDayLabel(dateKey, timeZone)
		});
	});
	return groups;
}
function groupInstancesByStartCalendarDay(instances, timeZone) {
	const groups = [];
	instances.forEach((instance) => {
		const dateKey = toZoned(instance.startsAt, timeZone).format("YYYY-MM-DD");
		const current = groups.at(-1);
		if (current?.dateKey === dateKey) {
			current.instances.push(instance);
			return;
		}
		groups.push({
			dateKey,
			instances: [instance],
			label: formatDayLabel(dateKey, timeZone)
		});
	});
	return groups;
}
//#endregion
export { groupInstancesByCalendarDay, groupInstancesByStartCalendarDay };

//# sourceMappingURL=group-instances-by-day.js.map